import React, { useEffect, useState } from 'react';
import { Badge, Button, Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/items.jpg';
import axios from 'axios';
import { toast } from 'react-toastify';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker'; 



const EditItem = ({ show, onClose, data  , onSuccess}) => {
      const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

  const [checkedItems, setCheckedItems] = useState({}); 
  const [expandedRow, setExpandedRow] = useState(null);
  const [reworkData, setReworkData] = useState({});
  const [staffOptions, setStaffOptions] = useState([]);
  const [submittedItems, setSubmittedItems] = useState({});
  const [initialCheckedItems, setInitialCheckedItems] = useState({});
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (data?.item_checklist?.length > 0) {
      const initChecked = {};
      const initRework = {};
      const initSubmitted = {};
      data.item_checklist.forEach((item) => {
        const isChecked = item.checklist_status === 0;
        initChecked[item.id] = isChecked;
        if (isChecked) initSubmitted[item.id] = true;
        initRework[item.id] = {
          startTime: item.rework_start_time || '',
          endTime: item.rework_end_time || '',
          staffId: item.rework_staff_id || '',
          staffName: item.rework_staff_name || '',
          description: item.rework_description || '',
        };
      });
      setCheckedItems(initChecked);
      setInitialCheckedItems(initChecked);
      setSubmittedItems(initSubmitted);
      setReworkData(initRework);
    }
  }, [data]);

  useEffect(() => {
    if (show) {
      axios
        .get(`${baseURL}/active-staff`)
        .then((res) => {
          const options = res.data.data.map((s) => ({
            value: s.id,
            label: s.name,
          }));
          setStaffOptions(options);
        })
        .catch((err) => {
          console.error('Failed to fetch staff list', err);
          toast.error('Failed to load staff list');
        });
    }
  }, [show, baseURL]);

  useEffect(() => {
    if (!show) {
      setSubmittedItems({});
    }
  }, [show]);

  const handleCheckboxChange = (id) => {
    if (initialCheckedItems[id]) return; // prevent unchecking pre-selected ones
    const updatedChecked = !checkedItems[id];
    setCheckedItems((prev) => ({
      ...prev,
      [id]: updatedChecked,
    }));
    if (updatedChecked) {
      setSubmittedItems((prev) => ({
        ...prev,
        [id]: true,
      }));
    } else {
      setSubmittedItems((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
    }
    if (checkedItems[id]) {
      setExpandedRow(null);
    }
  };

  const handleAssign = (item) => {
    setExpandedRow((prev) => (prev === item.id ? null : item.id));
  };

  const handleReworkChange = (id, field, value) => {
    setReworkData((prev) => {
      const updated = { ...prev[id], [field]: value ?? '' };
      if (field === 'staffId') {
        const staff = staffOptions.find((s) => s.value === value);
        updated.staffName = staff ? staff.label : '';
      }
      return { ...prev, [id]: updated };
    });
  };

  const handleChecklistSubmit = () => {
    const payload = {
      item_checklist: data.item_checklist.map((item) => {
        const start = reworkData[item.id]?.startTime;
        const end = reworkData[item.id]?.endTime;

        return {
          id: item.id,
          quality_name: item.quality_name,
          priority_id: item.priority_id ?? null,
          priority_name: item.priority_name ?? '',
          checklist_status: checkedItems[item.id] ? 0 : 1,
          rework_start_time: typeof start === 'string' && start.trim() !== '' ? start : null,
          rework_end_time: typeof end === 'string' && end.trim() !== '' ? end : null,
          rework_staff_id: reworkData[item.id]?.staffId ? parseInt(reworkData[item.id].staffId, 10) : null,
          rework_staff_name: reworkData[item.id]?.staffName || '',
          rework_description: reworkData[item.id]?.description || '',
        };
      }),
    };

    axios
      .post(`${baseURL}/work-assignment/update-checklist/${data.sno}`, payload)
      .then(() => {
        // toast.success('Checklist updated successfully!');
        const submitted = {};
        data.item_checklist.forEach((item) => {
          submitted[item.id] = true;
        });
        setSubmittedItems(submitted);
         toast.success("Checklist updated successfully!");
                        if (onSuccess) {
                          onSuccess(); // e.g., trigger data refetch or update state
                        }
                          onClose(); // Close modal or form
        // onClose();
      })
      .catch((err) => {
        console.error('Checklist update failed', err);
        toast.error('Something went wrong!');
      });
  };

  const getDateObjectFromTime = (timeStr) => {
    if (!timeStr) return '';
    const [hour, minute] = timeStr.split(':');
    return new DateObject({ hour, minute });
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Quality Analysis Checklist</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">

            
      

          <div className='row mb-2'>
              <div className='col-lg-6 mb-2'>
                  <div className="d-flex align-items-center justify-content-start gap-2">
                      <LightGallery
                          onInit={onInit}
                          speed={500}
                          plugins={[lgThumbnail, lgZoom]}
                      >
                          <div data-src={data?.item_info?.image || idly}  className='border rounded px-1 py-0'>
                              <img src={data?.item_info?.image || idly} alt={data?.item_info?.name} className='cursor-pointer w-60px h-60px' />
                          </div>
                      </LightGallery>
                      <div>
                          <label className='text-danger font-w600 fs-5'>{data?.item_info?.name}</label>
                          <div className="d-block">
                              <label className="fs-7 text-dark">{data?.item_info?.category} / {data?.item_info?.sub_category}</label>
                          </div>
                      </div>
                  </div>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                  <label className='text-gray-800 font-w500 fs-7'>Qty / Units</label>
                  <label className='text-black fs-6 font-w500'>200 No's</label>
              </div>
          </div>

          <div className='row mb-2'>
            <div className='col-lg-12 col-md-6 col-sm-6 mb-2'>
              <div className='d-flex flex-row align-items-center justify-content-start gap-2'>
                <label className='font-w500 text-black fs-6'>Approval Checklist</label>
                <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Approval Checklist</span></Tooltip>} >
                  <label className='text-black font-w500 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#ffc74b'}}>{data?.item_checklist?.length || 0}</label>
                </OverlayTrigger>
                <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Checked Approvals</span></Tooltip>} >
                  <label className='text-black font-w500 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#7ed30e'}}>{Object.values(checkedItems).filter(Boolean).length || 0}</label>
                </OverlayTrigger>
                <OverlayTrigger overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Unchecked Approvals</span></Tooltip>} >
                  <label className='text-black font-w500 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#09cdbb'}}>{data?.item_checklist?.length - Object.values(checkedItems).filter(Boolean).length || 0}</label>
                </OverlayTrigger>
              </div>
            </div>
          </div>
             <div className='row mb-2'>
            <div className='col-lg-12 col-md-6 col-sm-6 mb-2'> 
          {/* <div
            className="table-container mb-4"
            style={{
              maxHeight: data?.item_checklist?.length > 4 ? '250px' : 'auto',
              overflowY: 'auto',
              border: '1px solid #e4e6ef',
              borderRadius: '0.5rem',
            }}
            > */}
             <div className="table-container"> 
           <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
            <thead>
              <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                <th className='min-w-50px text-center'></th>
                <th className='min-w-100px'>Approval Quality Check</th>
                <th className='min-w-100px text-center'>Priority</th>
                <th className='min-w-50px text-center'>Approved / Rework</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold fs-7">
              {data?.item_checklist?.map((check) => (
                <React.Fragment key={check.id}>
                  <tr>
                    <td className="text-center">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={checkedItems[check.id] || false}
                        onChange={() => handleCheckboxChange(check.id)}
                        disabled={initialCheckedItems[check.id]}
                      />
                    </td>
                    <td>{check.quality_name}</td>
                    <td>{check.priority_name}</td>
                    {/* <td className="text-center">
                      {!checkedItems[check.id] && (
                        <Button
                          variant="primary"
                          className="btn-sm px-1 py-0 fw-semibold fs-8"
                          style={{ fontSize: '11px', lineHeight: '1.1', height: '26px' }}
                          onClick={() => handleAssign(check)}
                        >
                          Assign <i className="fas fa-angle-double-right ms-1"></i>
                        </Button>
                      )}
                    </td> */}
                    <td className="text-center">
                      {checkedItems[check.id] ? (
                        <label
                          className="font-w500 fs-7 text-white py-1 px-2 rounded"
                          style={{ backgroundColor: '#00abdf' }}
                        >
                          Approved
                        </label>
                      ) : (
                        <Button
                          variant="primary"
                          className="btn-sm px-1 py-0 fw-semibold fs-8"
                          style={{ fontSize: '11px', lineHeight: '1.1', height: '26px' }}
                          onClick={() => handleAssign(check)}
                        >
                          Assign <i className="fas fa-angle-double-right ms-1"></i>
                        </Button>
                      )}
                    </td>

                  </tr>

                  {expandedRow === check.id && (
                    <tr style={{ border: '2px solid black' }}>
                      <td colSpan="4" className="bg-light p-3 border-0">
                        <div className="row mt-1">
                          {/* Start Time */}
                          <div className="col-lg-4 mb-2">
                            <label className="text-black font-w500 fs-7">
                              Start Time<span className="required">*</span>
                            </label>
                            <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                              <div className="input-group-text bg-transparent border-0 px-0">
                                <i className="fa-solid fa-clock fs-4"></i>
                              </div>
                              <DatePicker
                                placeholder="Reassign Start Time"
                                disableDayPicker
                                value={getDateObjectFromTime(reworkData[check.id]?.startTime)}
                                onChange={(val) =>
                                  handleReworkChange(check.id, 'startTime', val?.format('HH:mm') || '')
                                }
                                format="HH:mm"
                                plugins={[<TimePicker position="bottom" />]}
                                editable={false}
                                className="w-100"
                              />
                            </div>
                          </div>

                          {/* End Time */}
                          <div className="col-lg-4 mb-2">
                            <label className="text-black font-w500 fs-7">
                              End Time<span className="required">*</span>
                            </label>
                            <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                              <div className="input-group-text bg-transparent border-0 px-0">
                                <i className="fa-solid fa-clock fs-4"></i>
                              </div>
                              <DatePicker
                                placeholder="Reassign End Time"
                                disableDayPicker
                                value={getDateObjectFromTime(reworkData[check.id]?.endTime)}
                                onChange={(val) =>
                                  handleReworkChange(check.id, 'endTime', val?.format('HH:mm') || '')
                                }
                                format="HH:mm"
                                plugins={[<TimePicker position="bottom" />]}
                                editable={false}
                                className="w-100"
                              />
                            </div>
                          </div>

                          {/* Staff */}
                          <div className="col-lg-4 mb-2">
                            <label className="text-black font-w500 fs-7">
                              Staff<span className="required">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={reworkData[check.id]?.staffId || ''}
                              onChange={(e) => handleReworkChange(check.id, 'staffId', e.target.value)}
                            >
                              <option value="">Select Staff</option>
                              {staffOptions.map((staff) => (
                                <option key={staff.value} value={staff.value}>
                                  {staff.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Description */}
                          <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                              Description<span className="required">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              placeholder="Enter Description"
                              value={reworkData[check.id]?.description || ''}
                              onChange={(e) =>
                                handleReworkChange(check.id, 'description', e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
          </div> 
          </div>

          
          {parseInt(data?.workassignment_status) !== 5 && (
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-2">
              <Button variant="primary" className="btn-sm" onClick={handleChecklistSubmit}>
                Submit <i className="fas fa-angle-double-right ms-2"></i>
              </Button>
            </div>
          )}

        </div>
      </div>
    </Modal>
  );
};

export default EditItem;
